// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2jWwK","row":"Node_row__1wI9m","label":"Node_label__nuWbi","footer":"Node_footer__2v8rW"};